import throttle from 'lodash.throttle';

export default class Header {
	constructor() {
		this.header = document.querySelector('.c-header-bar');

		document.addEventListener(
			'scroll',
			throttle((e) => this.checkScroll(), 100),
		);

		document.addEventListener('close-menu', (e) => {
			if (!this.shouldScroll()) {
				this.unStick();
			}
		});

		this.prevScroll = 0;

		this.checkScroll();
	}

	checkScroll() {
		if (!this.shouldScroll()) {
			return;
		}

		if (!document.body.classList.contains('body--transitioning')) {
			window.scrollY > 80 ? this.stick() : this.unStick();
		}

		this.prevScroll = window.scrollY;
	}

	stick() {
		document.body.classList.add('has-scrolled', 'has-menu-sticky');
		if(this.prevScroll>window.scrollY) {
			document.body.classList.add('has-scrolled-up');
			document.body.classList.remove('has-scrolled-down');
		} else {
			document.body.classList.add('has-scrolled-down');
			document.body.classList.remove('has-scrolled-up');
		}
	}

	unStick() {
		document.body.classList.remove('has-scrolled', 'has-menu-sticky');
	}

	shouldScroll() {
		const headerBar = document.querySelector('.c-header-bar');
		if (headerBar) {
			return headerBar.hasAttribute('data-show-on-scroll');
		} else {
			return false;
		}
	}
}
